import React from 'react';
import TimesheetHistory from '../components/timesheet/TimesheetHistory';

const History = () => {
  return <TimesheetHistory />;
};

export default History;
